import PropTypes from 'prop-types';

import SignupPromoTermsModal from 'features/site/SignupPromoTermsModal';
import { FallbackTermsAndConditions } from 'features/site/SignupPromoTermsModal/FallbackTermsAndConditions';
import NanoBanner from 'honeydew/NanoBanner';
import { logMessage } from 'utils/sentryUtils';

export const getFormattedDiscount = ({ code = '', type, valid, value }) => {
    let formattedDiscount;

    switch (type) {
        case 'dollars':
            formattedDiscount = `$${value}`;
            break;
        case 'percentage':
            formattedDiscount = `${value}%`;
            break;
        default:
            logMessage('getFormattedDiscount() hit default case', {
                level: 'warning',
                extra: { discount_type: type, value, code, valid },
            });
    }

    return formattedDiscount;
};

function SignupNanoBanner({ discountCodeData, setShowPromoTermsModal, showPromoTermsModal }) {
    const {
        code,
        nanobarTerms: nanobarTermsFromAPI,
        nanobarText: nanobarTextFromAPI,
        type,
        valid,
        value,
    } = discountCodeData?.disc ?? {};

    const nanobarText =
        nanobarTextFromAPI ||
        `Limited-time offer: ${getFormattedDiscount({
            code,
            type,
            valid,
            value,
        })} off your first order with code ${code}`;

    const nanobarTerms = nanobarTermsFromAPI || (
        <FallbackTermsAndConditions disc={discountCodeData?.disc} claimBy={discountCodeData?.claimBy} />
    );

    return (
        <>
            <SignupPromoTermsModal
                showPromoTermsModal={showPromoTermsModal}
                setShowPromoTermsModal={setShowPromoTermsModal}
                termsAndConditions={nanobarTerms}
            />
            {discountCodeData && (
                <NanoBanner
                    boldCopy={nanobarText}
                    link="Learn more"
                    onClick={() => setShowPromoTermsModal(true)}
                    signupBanner
                />
            )}
        </>
    );
}

SignupNanoBanner.propTypes = {
    discountCodeData: PropTypes.shape({
        claimBy: PropTypes.shape({
            date: PropTypes.string,
        }),
        disc: PropTypes.shape({
            nanobarTerms: PropTypes.string,
            nanobarText: PropTypes.string,
        }),
    }),
    setShowPromoTermsModal: PropTypes.func.isRequired,
    showPromoTermsModal: PropTypes.bool.isRequired,
};

SignupNanoBanner.defaultProps = {
    discountCodeData: undefined,
};

export default SignupNanoBanner;
